"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSRRenderContext = void 0;
const react_1 = __importDefault(require("react"));
exports.SSRRenderContext = react_1.default.createContext(null);
exports.default = exports.SSRRenderContext;
//# sourceMappingURL=ssr-render-context.js.map